document.addEventListener('DOMContentLoaded', function () {
  if(document.querySelector('#brandFirst-slider')) {
    const bannerSlider = new Splide('#brandFirst-slider', {
      type: "loop",  
      direction: 'ttb', 
      height   : 'fit-content',
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: 1.5
      },
    }).mount(window.splide.Extensions);
  }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if(document.querySelector('#brandSecond-slider')) {
    const bannerSlider = new Splide('#brandSecond-slider', {
        type: "loop",  
        direction: 'ttb', 
        height   : 'fit-content',
        arrows: false,
        pagination: false,
        autoScroll: {
          speed: -1.5
        },
    }).mount(window.splide.Extensions);
  }
  });

/* ---- Partners Review Tabs ---- */

document.addEventListener('DOMContentLoaded', ()=>{
  class ReviewSection extends HTMLElement {
    constructor() {
        super();
        this.inputValue = 1;
        this.initialRender();
        this.querySelectorAll('.block_heading').forEach((value) => {
            value.addEventListener('click', this.renderSection)
        });
        this.tabsSwitch = document.querySelector('.tabs__switch');
    }

    initialRender() {
        if (this.inputValue == 1) {
            let renderContent = document.querySelector(`.block__item[data-index="${this.inputValue}"]`);
            renderContent.classList.remove('inactive_ct');
            renderContent.classList.add('active_ct');
            let renderTabs = document.querySelector(`.block_heading[data-index="${this.inputValue}"]`);
            renderTabs.classList.remove('inactive__tab_ct');
            renderTabs.classList.add('active__tab_ct');
        }
    }

    renderSection() {
        let localValue = this.dataset.index;
        document.querySelectorAll('.block_heading').forEach((item) =>{
            item.classList.remove('active__tab_ct')
            item.classList.add('inactive__tab_ct');
        })
        document.querySelectorAll('.block__item').forEach((item) =>{
            item.classList.remove('active_ct')
            item.classList.add('inactive_ct');
        })
        let changeRenderTabs = document.querySelector(`.block__item[data-index="${localValue}"]`)
        changeRenderTabs.classList.remove('inactive_ct');
        changeRenderTabs.classList.add('active_ct');
        let renderTabs = document.querySelector(`.block_heading[data-index="${localValue}"]`);
        renderTabs.classList.remove('inactive__tab_ct');
        renderTabs.classList.add('active__tab_ct');
    }

  }
  

customElements.define('review-section', ReviewSection);
});

// Selecting First 2 letters of the paragraph and adding styles 

// document.addEventListener("DOMContentLoaded", function() {

//   const spanElement = document.querySelector('.review__desc');

//   if (spanElement) {
//       // Get the text content of the span element
//       const textContent = spanElement.textContent;

//       // Check if the text content has at least two characters
//       if (textContent.length >= 2) {
//           // Extract the first two letters of the text content
//           const firstTwoLetters = textContent.slice(0, 2);

//           let fontSizeStyle = '';


//           // Adding Different font-sizes for different screens
          
//           if(window.innerWidth <= 800){
//             fontSizeStyle = 'font-size: 15px;';
//           }
//           else{
//             fontSizeStyle = 'font-size: 40px;';
//           }

//           // Wrap the first two letters in a span element and apply CSS
//           const styledFirstTwoLetters = '<span class="two__letters" style="font-weight: 600;' + fontSizeStyle + '">' + firstTwoLetters + '</span>';
//           // Replace the first two letters in the text content with the styled first two letters
//           const styledText = textContent.replace(firstTwoLetters, styledFirstTwoLetters);

//           // Update the span element's HTML with the styled text
//           spanElement.innerHTML = styledText;
//       }
//   }
// });


/* ---_ Partners Registration JS ---- */

document.addEventListener('DOMContentLoaded', ()=>{
  class RegisterForm extends HTMLElement {
    constructor() {
        super();
        this.inputValue = 1;
        this.initialRender();
        this.querySelectorAll('.nav__item').forEach((value) => {
            value.addEventListener('click', this.renderSection)
        });
    }

    initialRender() {
        if (this.inputValue == 1) {
            let renderContent = document.querySelector(`.form__item[data-index="${this.inputValue}"]`);
            renderContent.classList.remove('inactive_rf');
            renderContent.classList.add('active_rf');
            let renderTabs = document.querySelector(`.nav__item[data-index="${this.inputValue}"]`);
            renderTabs.classList.remove('inactive__tab_rf');
            renderTabs.classList.add('active__tab_rf');
        }
    }

    renderSection() {
        let localValue = this.dataset.index;
        document.querySelectorAll('.nav__item').forEach((item) =>{
            item.classList.remove('active__tab_rf')
            item.classList.add('inactive__tab_rf');
        })
        document.querySelectorAll('.form__item').forEach((item) =>{
            item.classList.remove('active_rf')
            item.classList.add('inactive_rf');
        })
        let changeRenderTabs = document.querySelector(`.form__item[data-index="${localValue}"]`)
        changeRenderTabs.classList.remove('inactive_rf');
        changeRenderTabs.classList.add('active_rf');
        let renderTabs = document.querySelector(`.nav__item[data-index="${localValue}"]`);
        renderTabs.classList.remove('inactive__tab_rf');
        renderTabs.classList.add('active__tab_rf');
    }

  }
  

customElements.define('register-form', RegisterForm);
});
